import Splide from "@splidejs/splide";
import DOMReady from "./utils/DOMReady";
import YTLoader from "./utils/YTLoader";
import lazyLoad from "./modules/lazy-load";
import svgLoader from "./modules/svg-loader";
import { hero } from "./modules/hero";
import "./modules/experiences-grid";
import "./modules/gallery-slider";
import "../css/main.scss";
import "./global/header";
DOMReady(function () {
    YTLoader.init();
    lazyLoad.init();
    svgLoader.init();
    hero();
    function isHTMLElement(element) {
        return element instanceof HTMLElement;
    }
    // Hero slider (main homepage slider)
    var heroSplide = document.getElementById("splide");
    if (heroSplide && isHTMLElement(heroSplide)) {
        new Splide(heroSplide, {
            type: "fade",
            rewind: true,
            arrows: true,
            autoplay: true,
            interval: 6000,
            speed: 1500,
            pauseOnHover: false,
            pauseOnFocus: false,
            cover: true,
            heightRatio: 1,
            pagination: false,
            progress: true,
        }).mount();
    }
});
